<template>
  <VFiltersPopup
      :title-list="titleList"
      @submit="applyFilters"
      @clear="clearFilters"
  >
    <section class="outer-filter-container">
      <VSelect
          multiple
          v-model="draft.documentClass"
          label="Тип документа"
          placeholder="Выберите тип"
          :clearable="!filters.isLocked('documentClass')"
          :disabled="filters.isLocked('documentClass')"
          layout="vertical"
          :options="TransportableDocumentsFilter.DocumentClassOptions"
      />

      <VSelect
          v-model="draft.sender"
          label="Поставщик"
          placeholder="Название партнера"
          :clearable="!filters.isLocked('sender')"
          :disabled="filters.isLocked('sender')"
          layout="vertical"
					:search-function="PartnersService.searchSellers"
      />

      <VSelect
          label="Транспортная зона склада поставщика"
          v-model="draft.sellerTransportZone"
          placeholder="Выберите транспортную зону"
          :clearable="!filters.isLocked('sellerTransportZone')"
          :disabled="filters.isLocked('sellerTransportZone')"
          multiple
          layout="vertical"
          :search-function="pattern => TransportZonesService.getList(pattern)"
          options-nested-prepend
          :options-nested="nestedTransportZoneOptions"
      />

      <VSelect
          v-model="draft.buyerStore"
          label="Склад покупателя"
          placeholder="Выберите склад"
          :clearable="!filters.isLocked('buyerStore')"
          :disabled="filters.isLocked('buyerStore')"
          layout="vertical"
          :options-nested="$core.currentPartner!.stores"
      />
    </section>
  </VFiltersPopup>
</template>

<script lang="ts">
import VFiltersPopup                         from '@/components/VFiltersPopup/VFiltersPopup.vue';
import StoresService                from '@/domains/Stores/StoresService';
import TransportableDocumentsFilter from "@/domains/TransportableDocuments/components/TransportableDocumentsRegistry/TransportableDocumentsFilter";
import PartnersService              from "@/domains/Partners/PartnersService";
import TransportZonesService                 from "@/domains/TransportZones/TransportZonesService";

export default defineComponent({
  name: 'TransportableDocumentsFilter',

  components: {
    VFiltersPopup,
  },

  props: {
    filters: {
      type: Object as PropType<TransportableDocumentsFilter>,
      required: true,
    },
  },

  emits: ['transport-orders-page-filter:updated'],

  data() {
    return {
      PartnersService,
      StoresService,
      TransportZonesService,
      TransportableDocumentsFilter,
      draft: this.$core.utils.cloneDeep(this.filters),

      nestedTransportZoneOptions: [
        {
          "name": "Москва и МО",
          "id": 1,
          "version": 2,
          "isDeleted": false,
          "sticker": null
        },
        {
          "name": "СПб и ЛО",
          "id": 5,
          "version": 1,
          "isDeleted": false,
          "sticker": null
        }
      ]
    };
  },

  computed: {
    titleList(): string[] {
      const texts: string[] = [];

      if (this.filters.sender?.name) {
        texts.push(this.filters.sender.name);
      }

      if (this.$core.utils.isNotEmptyArray(this.filters.sellerTransportZone)) {
        const zones = this.filters.sellerTransportZone.map(_item => _item.name);
        zones[0] = `Транспортные зоны: ${zones[0]}`

        texts.push(...zones);
      }

      if (this.$core.utils.isNotEmptyArray(this.filters.documentClass)) {
        const documentClasses = this.filters.documentClass.map(_item => _item.name);
        documentClasses[0] = `Типы документов: ${documentClasses[0]}`

        texts.push(...documentClasses)
      }

      if (this.filters.buyerStore?.address.stringRepresentation) {
        texts.push(this.filters.buyerStore.address.stringRepresentation);
      }

      return texts;
    },
  },

  methods: {
    applyFilters(): void {
      this.draft.apply();

      this.$emit(TransportableDocumentsFilter.Events.Updated, this.draft);

      this.draft = this.$core.utils.cloneDeep(this.draft);
    },

    async clearFilters(): void {
      this.filters.reset();

      this.draft = this.$core.utils.cloneDeep(this.filters);
      this.draft.apply();

      await this.$nextTick()

      this.$emit(TransportableDocumentsFilter.Events.Updated, this.filters);
    },
  },
});
</script>
